import React, { lazy, Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import { ContainerLoader } from "../../components/loader";
import Leads, { LeadDetails } from "../leads";
import AuthenticateRoute from "./AuthenticateRoute";
import { RouteKeys } from "./route-keys";
import RedirectIfAuthenticatedRoute from "./RedirectIfAuthenticatedRoute";
import Roles from "../roles";
import GeneralSettingsPage from "../general-settings";
import ContentSettingsPage from "../content-settings/content-settings-page";
import RolesAcceessibilityPage from "../roles-acceessibility";
import PropertyListing from "../Properties/Property-listing";
import PropertyDetailsPage from "../propert-details/propertyDetails";
import ForgotPassword from "../auth/forgotPassword";
import ResetPassword from "../auth/resetPassword";
import RequirementsList from "../requirements/requirementsList";
import ScheduleSiteVisit from "../schedule-site-visit/scheduleSiteVisit";
import TenancyExpiryList from "../tenancy-expiry-tracker/TenancyExpiryList";
import InvoiceList from "../special-approvals/invoice-list/invoice-list";
import InvoiceSettings from "../invoice-settings";
import ProposalList from "../special-approvals/proposalList";
import TermsheetList from "../special-approvals/termsheetList";
import LoiList from "../special-approvals/loi";
import AgreementList from "../special-approvals/agreementList";
import FeeLetterList from "../special-approvals/fee-letter-list/fee-letter-list";
import Transactions from "../transaction360";
import MediaSettingsPage from "../media-settings/MediaSettings";
const Home = lazy(() => import("../home"));

const Login = lazy(() => import("../auth/Login"));
const AzureLogin = lazy(() => import("../auth/AzureLogin"));
const NotFound = lazy(() => import("../notfound"));

const LeadSettings = lazy(() => import("../leads-settings"));
const CompanySettings = lazy(() => import("../company-settings"));
const StaffMembers = lazy(() => import("../staff-members"));
const EnquiryScreen = lazy(() => import("../enquiry"));

const EnquiryDetailsScreen = lazy(() => import("../enquiry/EnquiryDetails"));
const Lead360View = lazy(() => import("../lead-360-view"));
const ShowroomManagement = lazy(() => import("../showroom-management"));
const CalendarScreen = lazy(() => import("../calendar/calendar-screen"));

const ActivitySummaryReportScreen = lazy(
  () => import("../reports/activity-summary-report")
);
const SiteVisitReportReportScreen = lazy(
  () => import("../reports/site-visit-report")
);

const Customers = lazy(() => import("../customer"));

const Search = lazy(() => import("../search"));
const Profile = lazy(() => import("../staff-profile"));
const LeadLostRequests = lazy(() => import("../lead-lost-requests"));
const Projects = lazy(() => import("../Properties/projects"));
const ProjectDetailsPage = lazy(
  () => import("../project-details/projectDetails")
);

const CompanyList = lazy(() => import("../company/CompanyList"));
// const Company360View = lazy(() => import("../company-360-view"));

const requirementPropertyDetailPopup = lazy(
  () => import("../requirement-detail-popup/requirementPropertyDetailPopup")
);
const RequirementComparePage = lazy(
  () => import("../requirement-detail-popup/requirementComparePopup")
);
const RequirementListingPage = lazy(
  () => import("../requirement-listing/requirementListingPopup")
);

const RequirementSettings = lazy(() => import("../requirement-settings"));
const ProposalSettings = lazy(() => import("../proposal-settings"));
const ProposalPage = lazy(() => import("../proposal"));
const ProposalPopup = lazy(
  () => import("../requirement-listing/proposalPopup")
);
const RequirementPage = lazy(() => import("../requirement"));
const AgreementPage = lazy(() => import("../agreement"));
const InvoicePage = lazy(() => import("../invoice"));
const LegalDueDiligenceSettings = lazy(
  () => import("../legal-due-diligence-settings")
);
const DocumentSettings = lazy(() => import("../document-settings"));
const GlobalSearch = lazy(() => import("../global-search"));
const Company360 = lazy(() => import("../Company360/index"));
const MediaSettings = lazy(() => import("../media-settings"));

class Routes extends React.Component {
  render() {
    return (
      <Suspense fallback={<ContainerLoader height={500} text={"Loading..."} />}>
        <Switch>
          <RedirectIfAuthenticatedRoute
            path={RouteKeys.Login}
            component={Login}
          />
          <RedirectIfAuthenticatedRoute
            path={RouteKeys.AzureLogin}
            component={AzureLogin}
          />
          <AuthenticateRoute exact path={RouteKeys.Home} component={Home} />

          <AuthenticateRoute exact path={RouteKeys.Leads} component={Leads} />
          <AuthenticateRoute
            exact
            path={`${RouteKeys.Leads}/:id`}
            component={LeadDetails}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.Calendar}
            component={CalendarScreen}
          />

          <AuthenticateRoute
            exact
            path={RouteKeys.Properties}
            component={PropertyListing}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.Enquiry}
            component={EnquiryScreen}
          />
          <AuthenticateRoute
            exact
            path={`${RouteKeys.Enquiry}/:id`}
            component={EnquiryDetailsScreen}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.Lead360View}
            component={Lead360View}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.Projects}
            component={Projects}
          />
          <RedirectIfAuthenticatedRoute
            path={RouteKeys.ForgotPassword}
            component={ForgotPassword}
          />
          <RedirectIfAuthenticatedRoute
            path={RouteKeys.ResetPassword}
            component={ResetPassword}
          />

          <AuthenticateRoute
            exact
            path={RouteKeys.ProjectDetails}
            component={ProjectDetailsPage}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.PropertyDetails}
            component={PropertyDetailsPage}
          />

          <AuthenticateRoute
            exact
            path={`${RouteKeys.Lead360View}/:customerId`}
            component={Lead360View}
          />
          {/* <AuthenticateRoute
            exact
            path={RouteKeys.Company360View}
            component={Company360View}
          />
          <AuthenticateRoute
            exact
            path={`${RouteKeys.Company360View}/:customerId`}
            component={Company360View}
          /> */}
          <AuthenticateRoute
            exact
            path={RouteKeys.LeadSettings}
            component={LeadSettings}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.CompanySettings}
            component={CompanySettings}
          />

          <AuthenticateRoute
            exact
            path={RouteKeys.ActivitySummaryReport}
            component={ActivitySummaryReportScreen}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.SiteVisitReport}
            component={SiteVisitReportReportScreen}
          />

          <AuthenticateRoute
            exact
            path={RouteKeys.GeneralSettings}
            component={GeneralSettingsPage}
          />

          <AuthenticateRoute
            exact
            path={RouteKeys.ContentSettings}
            component={ContentSettingsPage}
          />

          <AuthenticateRoute
            exact
            path={RouteKeys.StaffMembers}
            component={StaffMembers}
          />

          <AuthenticateRoute exact path={RouteKeys.Roles} component={Roles} />
          <AuthenticateRoute
            exact
            path={RouteKeys.ShowroomManagement}
            component={ShowroomManagement}
          />

          <AuthenticateRoute
            exact
            path={RouteKeys.Customers}
            component={Customers}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.Requirements}
            component={RequirementsList}
          />

          <AuthenticateRoute
            exact
            path={RouteKeys.InvoiceList}
            component={InvoiceList}
          />

          <AuthenticateRoute
            exact
            path={RouteKeys.ProposalList}
            component={ProposalList}
          />

          <AuthenticateRoute
            exact
            path={RouteKeys.TermSheetList}
            component={TermsheetList}
          />

          <AuthenticateRoute
            exact
            path={RouteKeys.LetterOfIntentList}
            component={LoiList}
          />

          <AuthenticateRoute
            exact
            path={RouteKeys.agreementList}
            component={AgreementList}
          />

          <AuthenticateRoute
            exact
            path={RouteKeys.feeLetterList}
            component={FeeLetterList}
          />

          <AuthenticateRoute
            exact
            path={`${RouteKeys.Search}/:query`}
            component={Search}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.Profile}
            component={Profile}
          />

          <AuthenticateRoute
            exact
            path={RouteKeys.LeadLostRequests}
            component={LeadLostRequests}
          />

          <AuthenticateRoute
            exact
            path={RouteKeys.RolesAcceessibility}
            component={RolesAcceessibilityPage}
          />

          <AuthenticateRoute
            exact
            path={RouteKeys.Company}
            component={CompanyList}
          />

          <AuthenticateRoute
            exact
            path={RouteKeys.Transaction360}
            component={Transactions}
          />

          <AuthenticateRoute
            exact
            path={RouteKeys.requirementPropertyDetailPopup}
            component={requirementPropertyDetailPopup}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.RequirementComparePage}
            component={RequirementComparePage}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.RequirementListingPage}
            component={RequirementListingPage}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.RequirementSettings}
            component={RequirementSettings}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.InvoiceSettings}
            component={InvoiceSettings}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.ProposalSettings}
            component={ProposalSettings}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.Proposal}
            component={ProposalPage}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.Agreement}
            component={AgreementPage}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.Invoice}
            component={InvoicePage}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.Requirement}
            component={RequirementPage}
          />

          <AuthenticateRoute
            exact
            path={RouteKeys.TenancyExpiryTracker}
            component={TenancyExpiryList}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.ScheduleSiteVisit}
            component={ScheduleSiteVisit}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.ProposalPopup}
            component={ProposalPopup}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.LegalDueDiligenceSettings}
            component={LegalDueDiligenceSettings}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.DocumentSettings}
            component={DocumentSettings}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.GlobalSearch}
            component={GlobalSearch}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.Company360View}
            component={Company360}
          />
          <AuthenticateRoute
            exact
            path={`${RouteKeys.Company360View}/:customerId`}
            component={Company360}
          />
          <AuthenticateRoute
            exact
            path={RouteKeys.MediaSettings}
            component={MediaSettingsPage}
          />
          <Route exact path={RouteKeys.NotFound} component={NotFound} />
        </Switch>
      </Suspense>
    );
  }
}

export default Routes;
